/**
 * Print mode is how Gotenberg's headless Chromium renders the final report into
 * a PDF: it loads `/interview/:id/report?print=1&token=...`. In this mode the
 * page is gated by a short-lived print token (not the user session), so the
 * normal auth gate and app chrome must be bypassed. Scoped to the report path
 * so `?print=1` can't loosen auth anywhere else.
 */
const REPORT_PRINT_PATH = /^\/interview\/[^/]+\/report$/;

export function isReportPrintMode(pathname: string, search: string): boolean {
  if (!REPORT_PRINT_PATH.test(pathname)) return false;
  return new URLSearchParams(search).get('print') === '1';
}
